export {
  SUPPORTED_CV_LANGUAGE_NAMES,
  canonicalizeCvLanguageName,
  isSupportedCvLanguageName,
  type SupportedCvLanguageName,
} from './cv-validation';
